export default class IZAdmin {
    constructor() {
        this.maxFileSize = 10 * 1024 * 1024;
    }
    handleResponse(response, onSuccess, defaultUnexpectedMessage) {
        if (typeof defaultUnexpectedMessage == 'undefined') {
            defaultUnexpectedMessage = 'Unexpected error happen, please relogin ro refresh this page';
        }

        if (response.errCode == 0) {
            if (typeof onSuccess == 'function') {
                onSuccess(response.data);
            }
        } else if (typeof response.errMessage == 'undefined') {
            this.showError(defaultUnexpectedMessage);
        } else {
            this.showError(response.errMessage);
        }
    }
    showInfo(message) {
        window.toastr.info(message, 'Info', {
            positionClass: 'toast-top-right',
            closeButton: true,
            progressBar: true,
            preventDuplicates: false,
            newestOnTop: false

        });
    }
    closeLastModal() {
        return window.cresenity.closeLastModal();
    }
    showError(message) {
        window.toastr.error(message, 'Error', {
            positionClass: 'toast-top-right',
            closeButton: true,
            progressBar: true,
            preventDuplicates: false,
            newestOnTop: false

        });
    }
    showSuccess(message) {
        window.toastr.success(message, 'Success', {
            positionClass: 'toast-top-right',
            closeButton: true,
            progressBar: true,
            preventDuplicates: false,
            newestOnTop: false

        });
    }
    formatNumber(rp) {
        rp = '' + rp;
        var rupiah = '';
        var vfloat = '';
        var ds = window.capp.decimal_separator;
        var ts = window.capp.thousand_separator;
        var dd = window.capp.decimal_digit;
        dd = parseInt(dd);
        var minusStr = '';
        if (rp.indexOf('-') >= 0) {
            minusStr = rp.substring(rp.indexOf('-'), 1);
            rp = rp.substring(rp.indexOf('-') + 1);
        }

        if (rp.indexOf('.') >= 0) {
            vfloat = rp.substring(rp.indexOf('.'));
            rp = rp.substring(0, rp.indexOf('.'));
        }
        let p = rp.length;
        while (p > 3) {
            rupiah = ts + rp.substring(p - 3) + rupiah;
            let l = rp.length - 3;
            rp = rp.substring(0, l);
            p = rp.length;
        }
        rupiah = rp + rupiah;
        vfloat = vfloat.replace('.', ds);
        if (vfloat.length > dd) {
            vfloat = vfloat.substring(0, dd + 1);
        }
        return minusStr + rupiah + vfloat;
    }
    formatNumberPeriodSeparator(rp) {
        rp = '' + rp;
        var rupiah = '';
        var vfloat = '';
        var ds = ',';
        var ts = '.';
        var dd = 0;
        dd = parseInt(dd);
        var minusStr = '';
        if (rp.indexOf('-') >= 0) {
            minusStr = rp.substring(rp.indexOf('-'), 1);
            rp = rp.substring(rp.indexOf('-') + 1);
        }

        if (rp.indexOf('.') >= 0) {
            vfloat = rp.substring(rp.indexOf('.'));
            rp = rp.substring(0, rp.indexOf('.'));
        }
        let p = rp.length;
        while (p > 3) {
            rupiah = ts + rp.substring(p - 3) + rupiah;
            let l = rp.length - 3;
            rp = rp.substring(0, l);
            p = rp.length;
        }
        rupiah = rp + rupiah;
        vfloat = vfloat.replace('.', ds);
        if (vfloat.length > dd) {
            vfloat = vfloat.substring(0, dd + 1);
        }
        return minusStr + rupiah + vfloat;
    };
    formatCurrency(rp) {
        rp = '' + rp;
        var rupiah = '';
        var vfloat = '';
        var ds = window.capp.decimal_separator;
        var ts = window.capp.thousand_separator;
        var dd = 2;
        dd = parseInt(dd);
        var minusStr = '';
        if (rp.indexOf('-') >= 0) {
            minusStr = rp.substring(rp.indexOf('-'), 1);
            rp = rp.substring(rp.indexOf('-') + 1);
        }

        if (rp.indexOf('.') >= 0) {
            vfloat = rp.substring(rp.indexOf('.'));
            rp = rp.substring(0, rp.indexOf('.'));
        }
        let p = rp.length;
        while (p > 3) {
            rupiah = ts + rp.substring(p - 3) + rupiah;
            let l = rp.length - 3;
            rp = rp.substring(0, l);
            p = rp.length;
        }
        rupiah = rp + rupiah;
        vfloat = vfloat.replace('.', ds);
        if (vfloat.length > dd) {
            vfloat = vfloat.substring(0, dd + 1);
        }
        if(vfloat=='') {
            vfloat='.00';
        }
        return minusStr + rupiah + vfloat;
    };
    formatSize(size) {
        if (typeof size == 'undefined') {
            size = this.size;
        }
        var sizeStr = '';
        var sizeKB = size / 1024;
        if (parseInt(sizeKB) > 1024) {
            var sizeMB = sizeKB / 1024;
            if (parseInt(sizeMB) > 1024) {
                var sizeGB = sizeMB / 1024;
                sizeStr = sizeGB.toFixed(2) + ' GB';
            } else {
                sizeStr = sizeMB.toFixed(2) + ' MB';
            }
        } else {
            sizeStr = sizeKB.toFixed(2) + ' KB';
        }
        return sizeStr;
    }
    numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    numberToKilo(num) {
        return Math.abs(num) > 999 ? this.numberWithCommas(Math.sign(num) * (Math.abs(num) / 1000).toFixed(1)) + 'K' : Math.sign(num) * Math.abs(num);
    }
    blockPage() {
        return window.cresenity.blockPage();
    }
    unblockPage() {
        return window.cresenity.unblockPage();
    }
    blockElement(selector) {
        return window.cresenity.blockElement(selector);
    }
    unblockElement(selector) {
        return window.cresenity.unblockElement(selector);
    }

    reload(reloadOptions) {
        return window.cresenity.reload(reloadOptions);
    }
    append(appendOptions) {
        return window.cresenity.append(appendOptions);
    }
    prepend(prependOptions) {
        return window.cresenity.append(prependOptions);
    }
    modal(modalOptions) {
        if (modalOptions.isSidebar) {
            if (typeof modalOptions.onClose == 'undefined') {
                modalOptions.onClose = function (e, next) {
                    var $invoker = $(e.currentTarget);
                    $invoker.addClass('uninit');
                    setTimeout(function () {
                        $invoker.removeClass('uninit').addClass('inited');
                        $invoker.find('.modal-dialog').addClass('uninit');
                    }, 1);


                    next(500);
                };
            }
        }
        var modalContainer = window.cresenity.modal(modalOptions);
        if (modalOptions.isSidebar) {
            modalContainer.find('.modal-dialog').addClass('uninit');
            setTimeout(function () {
                modalContainer.find('.modal-dialog').removeClass('uninit').addClass('inited');
            }, 1);
        }
        return modalContainer;
    }
    showModal(message, options) {
        var settings = $.extend({
            // These are the defaults.
            haveHeader: false,
            haveFooter: false,
            onClose: false,
            headerText: '',
            footerAction: {}
        }, options);

        var modalContainer = jQuery('<div>').addClass('modal');
        var modalDialog = jQuery('<div>').addClass('modal-dialog');
        var modalContent = jQuery('<div>').addClass('modal-content animated bounceInDown');
        var modalHeader = jQuery('<div>').addClass('modal-header');
        var modalBody = jQuery('<div>').addClass('modal-body');
        var modalFooter = jQuery('<div>').addClass('modal-footer');

        modalBody.append(message);
        if (settings.haveHeader) {
            modalHeader.html(settings.headerText);
            modalContent.append(modalHeader);
        }
        modalContent.append(modalBody);
        if (settings.haveFooter) {
            modalContent.append(modalFooter);
        }
        modalContainer.append(modalDialog);
        modalDialog.append(modalContent);

        $('body').append(modalContainer);

        modalContainer.on('hidden.bs.modal', function () {
            if(typeof settings.onClose == 'function') {
                settings.onClose();
            }

            modalContainer.remove();
        });
        modalContainer.modal();
    }
    confirm(onConfirmed, message) {
        if (typeof message == 'undefined') {
            message = 'Are you sure?';
        }
        let confirmOptions = {};
        confirmOptions.message = message;
        confirmOptions.onConfirmed = onConfirmed;
        return window.cresenity.confirm(confirmOptions);
    }

    closeLastModal() {
        return window.cresenity.closeLastModal();
    }

    scrollTo(element, container) {
        return window.cresenity.scrollTo(element, container);
    }
    isDevelopment() {
        return window.capp.domain.includes('app.ittron.co.id') || window.capp.domain.includes('dev.ittron.co.id');
    }
}
